<template>
	<v-card v-if="domainStore.hasAccessRights(UserRole.Editor)">
		<v-container
			fluid
			style="
				background: rgb(var(--v-theme-contained));
				z-index: 1000;
				width: calc(100% - 2px);
				margin-right: 2px;
				display: flex;
				align-items: center;
				gap: 8px;
			"
		>
			<v-tooltip
				v-if="(debugStore.debugMode || debugStore.altKeyHeld) && domainStore.hasAccessRights(UserRole.Admin)"
				:text="`Sender: ${alternisNewStore.sender}`"
				location="top"
			>
				<template v-slot:activator="{ props: tooltipProps }">
					<div
						v-bind="tooltipProps"
						style="cursor: pointer"
						@click="alternisNewStore.sender = alternisNewStore.sender === 0 ? 1 : 0"
					>
						<Avatar
							:size="32"
							:text="alternisNewStore.sender === 0 ? '0' : '1'"
							:color="alternisNewStore.sender === 1 ? '#CFD1D5' : '#B0D8D7'"
						/>
					</div>
				</template>
			</v-tooltip>
			<v-textarea
				v-model="messageText"
				style="width: 100%; margin: 0 auto"
				variant="solo"
				:disabled="!alternisNewStore.sessionId"
				:placeholder="
					alternisNewStore.sessionId
						? symbolsStore.GUILabel('9c084d37-9c17-4706-afb1-2c001752792e')
						: symbolsStore.GUILabel('8ff020dd-f08d-4262-924d-1afc48a67c2f')
				"
				:rows="1"
				max-rows="5"
				append-inner-icon="mdi-send"
				no-resize
				auto-grow
				hide-details
				@keydown.enter="onEnter"
				@click:append-inner="sendTextMessage"
			>
			</v-textarea>
		</v-container>
	</v-card>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useDomainStore } from "../../../../store/domain";
import { useDebugStore } from "../../../../store/debug";
import { useSymbolsStore } from "../../../../store/symbols";
import { useInstanceWorkspacesStore } from "../../../../store/i-workspace";
import { Language, useAlternisNewStore } from "../../../../store/alternis_new";
import { UserRole } from "@lr-notitia/notitia-operator/schemas";
import Avatar from "./Avatar.vue";

const domainStore = useDomainStore();
const debugStore = useDebugStore();
const symbolsStore = useSymbolsStore();
const instanceWorkspacesStore = useInstanceWorkspacesStore();
const alternisNewStore = useAlternisNewStore();

const messageText = ref("");

function onEnter(e: KeyboardEvent) {
	if (e.shiftKey) {
		return;
	} else {
		e.preventDefault();
		e.stopPropagation();
		sendTextMessage();
	}
}
async function sendTextMessage() {
	if (!messageText.value) return;
	if (!instanceWorkspacesStore.openedWorkspaceId) return;

	await alternisNewStore.sendTextMessage(
		domainStore.domain.id,
		instanceWorkspacesStore.openedWorkspaceId,
		messageText.value,
		{
			sender: alternisNewStore.sender,
			emitImmediately: true,
			language: domainStore.languagePreference as Language,
		},
	);

	messageText.value = "";
}
</script>
